'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _CartStore = require('../../stores/CartStore');

var _CartStore2 = _interopRequireDefault(_CartStore);

var _Actions = require('../../Actions');

var _Actions2 = _interopRequireDefault(_Actions);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _SpinButton = require('../generic/SpinButton');

var _SpinButton2 = _interopRequireDefault(_SpinButton);

var _Utility = require('../../utils/Utility');

var Utils = _interopRequireWildcard(_Utility);

var _sweetalert = require('sweetalert2');

var _sweetalert2 = _interopRequireDefault(_sweetalert);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TipMain = function (_Component) {
    _inherits(TipMain, _Component);

    function TipMain(props) {
        _classCallCheck(this, TipMain);

        var _this = _possibleConstructorReturn(this, (TipMain.__proto__ || Object.getPrototypeOf(TipMain)).call(this, props));

        _this.compareTipProps = function (nextProps) {
            var tip = nextProps.tip,
                tipType = nextProps.tipType,
                tipPercent = nextProps.tipPercent;
            var _this$props = _this.props,
                otip = _this$props.otip,
                otipType = _this$props.otipType,
                otipPercent = _this$props.otipPercent;


            if (otip == tip && tipType == otipType && tipPercent == otipPercent) {
                return false;
            }

            return true;
        };

        _this.handleChange = function (event) {

            var val = Number(event.target.value);

            if (val < 1) {
                val = "";
            }

            _this.setState({
                customTipInput: val
            });
        };

        _this.clearCustomInput = function (e) {
            e.target.value = '';
        };

        _this.resetToPreviousState = function (e) {
            _this.setState(function (prevState) {
                return { customTipInput: prevState.customTipInput };
            });
        };

        _this.getTip = function (perc) {
            var str = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            var subTotal = _CartStore2.default.getCartSubTotalWithDiscountAbs();
            var tip = subTotal * perc / 100;
            if (str) {
                return _lodash2.default.round(tip, 2).toFixed(2);
            } else {
                return _lodash2.default.round(tip, 2);
            }
        };

        _this.setNoTip = function (e) {
            e.preventDefault();
            var style = {
                noTipActive: true,
                tenPercTipActive: false,
                fiftPercTipActive: false,
                twenPercTipActive: false,
                customTipActive: false
            };

            _this.setState({
                chosenCustomTip: 0,
                customTipInput: 0,
                chosenTip: 0,
                showCustomTipField: false,
                style: style
            });

            _Actions2.default.addTip(0, "notip", null);
        };

        _this.set10PercTip = function (e) {
            e.preventDefault();
            var style = {
                noTipActive: false,
                tenPercTipActive: true,
                fiftPercTipActive: false,
                twenPercTipActive: false,
                customTipActive: false
            };

            var tipAmount = _this.getTip(10, false);

            _this.setState({
                chosenCustomTip: 0,
                customTipInput: 0,
                showCustomTipField: false,
                chosenTip: tipAmount,
                style: style
            });

            _Actions2.default.addTip(tipAmount, "percent", 10);
        };

        _this.set15PercTip = function (e) {
            e.preventDefault();
            var style = {
                noTipActive: false,
                tenPercTipActive: false,
                fiftPercTipActive: true,
                twenPercTipActive: false,
                customTipActive: false
            };

            var tipAmount = _this.getTip(15, false);

            _this.setState({
                chosenCustomTip: 0,
                customTipInput: 0,
                showCustomTipField: false,
                chosenTip: tipAmount,
                style: style
            });

            _Actions2.default.addTip(tipAmount, "percent", 15);
        };

        _this.set20PercTip = function (e) {
            e.preventDefault();
            var style = {
                noTipActive: false,
                tenPercTipActive: false,
                fiftPercTipActive: false,
                twenPercTipActive: true,
                customTipActive: false
            };

            var tipAmount = _this.getTip(20, false);

            _this.setState({
                chosenCustomTip: 0,
                customTipInput: 0,
                showCustomTipField: false,
                chosenTip: tipAmount,
                style: style
            });

            _Actions2.default.addTip(tipAmount, "percent", 20);
        };

        _this.state = {
            chosenTip: 0,
            chosenCustomTip: 0,
            customTipInput: 0,
            showCustomTipField: false,
            style: {
                noTipActive: true,
                tenPercTipActive: false,
                fiftPercTipActive: false,
                twenPercTipActive: false,
                customTipActive: false
            }
        };
        return _this;
    }

    _createClass(TipMain, [{
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {
            var defaultStyles = {
                noTipActive: false,
                tenPercTipActive: false,
                fiftPercTipActive: false,
                twenPercTipActive: false,
                customTipActive: false
            };

            var _props = this.props,
                tip = _props.tip,
                tipType = _props.tipType,
                tipPercent = _props.tipPercent;


            if (tipType == "custom") {
                defaultStyles["customTipActive"] = true;
                this.setState({
                    style: defaultStyles,
                    chosenCustomTip: tip
                    // customTipInput  : tip
                });
            } else if (tipType == "percent") {
                if (tipPercent == 10) {
                    defaultStyles["tenPercTipActive"] = true;
                } else if (tipPercent == 20) {
                    defaultStyles["twenPercTipActive"] = true;
                } else {
                    defaultStyles["fiftPercTipActive"] = true;
                }

                this.setState({
                    style: defaultStyles
                });
            } else if (tipType == "notip") {
                defaultStyles["noTipActive"] = true;
                this.setState({
                    style: defaultStyles,
                    chosenCustomTip: 0,
                    customTipInput: 0,
                    chosenTip: 0,
                    showCustomTipField: false
                });
            }
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            var defaultStyles = {
                noTipActive: false,
                tenPercTipActive: false,
                fiftPercTipActive: false,
                twenPercTipActive: false,
                customTipActive: false
            };

            if (!this.compareTipProps(nextProps)) {
                return;
            }

            var tip = nextProps.tip,
                tipType = nextProps.tipType,
                tipPercent = nextProps.tipPercent;


            if (tipType == "custom") {
                defaultStyles["customTipActive"] = true;
                this.setState({
                    style: defaultStyles,
                    chosenCustomTip: tip
                });
            } else if (tipType == "percent") {
                if (tipPercent == 10) {
                    defaultStyles["tenPercTipActive"] = true;
                } else if (tipPercent == 20) {
                    defaultStyles["twenPercTipActive"] = true;
                } else {
                    defaultStyles["fiftPercTipActive"] = true;
                }

                this.setState({
                    style: defaultStyles
                });
            } else if (tipType == "notip") {
                defaultStyles["noTipActive"] = true;
                this.setState({
                    style: defaultStyles,
                    chosenCustomTip: 0,
                    customTipInput: 0,
                    chosenTip: 0
                    // showCustomTipField : false
                });
            }
        }

        // componentDidUpdate(){
        //     console.log(this.props);
        // }

    }, {
        key: 'applyCustomTip',
        value: function applyCustomTip() {
            var tipAmount = this.state.customTipInput;

            if (Utils.isEmpty(tipAmount)) {
                tipAmount = 0;
            }

            if (tipAmount < 0) {
                tipAmount = 0;

                _sweetalert2.default.fire({
                    title: 'Invalid Value!',
                    text: 'You are entering a negative value.',
                    icon: 'warning',
                    showConfirmButton: false,
                    showCancelButton: true,
                    cancelButtonText: 'Close',
                    customClass: {
                        cancelButton: "swal2-confirm custom-btn-outline-primary swal2-cancel custom-primary" + " text-capitalize"
                    },
                    allowOutsideClick: false
                });

                // break the function
                return;
            }

            var style = {
                noTipActive: false,
                tenPercTipActive: false,
                fiftPercTipActive: false,
                twenPercTipActive: false,
                customTipActive: true
            };

            this.setState(function (prevState, props) {
                return {
                    chosenCustomTip: tipAmount,
                    showCustomTipField: !prevState.showCustomTipField,
                    style: style
                };
            });

            _Actions2.default.addTip(tipAmount, "custom", null);
        }
    }, {
        key: 'setCustomTip',
        value: function setCustomTip(e) {
            e.preventDefault();
            this.setState({
                showCustomTipField: !this.state.showCustomTipField
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: 'tip-main pb-3 mb-0 ' + (this.props.isMobile ? "border-bottom" : "") },
                _react2.default.createElement(
                    'h6',
                    { className: 'mb-2 cart-heading f16-default' },
                    'Choose a Tip'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'btn-group btn-group-justified center-block w-100' },
                    _react2.default.createElement(
                        'a',
                        {
                            href: "#",
                            className: 'btn btn-tip btn-button-link ' + (this.state.style.noTipActive ? "active-styl" : ""),
                            onClick: function onClick(e) {
                                return _this2.setNoTip(e);
                            },
                            tabIndex: 33
                        },
                        _react2.default.createElement(
                            'b',
                            null,
                            'No tip'
                        )
                    ),
                    _react2.default.createElement(
                        'a',
                        {
                            href: "#",
                            className: 'btn btn-tip btn-button-link ' + (this.state.style.tenPercTipActive ? "active-styl" : ""),
                            onClick: function onClick(e) {
                                return _this2.set10PercTip(e);
                            },
                            tabIndex: 34

                            // tabIndex  = {10}
                            // tabIndex  = {-1}
                        },
                        _react2.default.createElement(
                            'b',
                            null,
                            '10%'
                        ),
                        ' ',
                        _react2.default.createElement('br', null),
                        ' $',
                        this.getTip(10)
                    ),
                    _react2.default.createElement(
                        'a',
                        {
                            href: "#",
                            className: 'btn btn-tip btn-button-link ' + (this.state.style.fiftPercTipActive ? "active-styl" : ""),
                            onClick: function onClick(e) {
                                return _this2.set15PercTip(e);
                            },
                            tabIndex: 35
                            // tabIndex  = {10}
                            // tabIndex  = {-1}
                        },
                        _react2.default.createElement(
                            'b',
                            null,
                            '15%'
                        ),
                        ' ',
                        _react2.default.createElement('br', null),
                        ' $',
                        this.getTip(15)
                    ),
                    _react2.default.createElement(
                        'a',
                        {
                            href: "#",
                            className: 'btn btn-tip btn-button-link ' + (this.state.style.twenPercTipActive ? "active-styl" : ""),
                            onClick: function onClick(e) {
                                return _this2.set20PercTip(e);
                            },
                            tabIndex: 36
                            // tabIndex  = {10}
                            // tabIndex  = {-1}
                        },
                        _react2.default.createElement(
                            'b',
                            null,
                            '20%'
                        ),
                        ' ',
                        _react2.default.createElement('br', null),
                        ' $',
                        this.getTip(20)
                    ),
                    _react2.default.createElement(
                        'a',
                        {
                            href: "#",
                            className: 'btn btn-tip btn-button-link ' + (this.state.style.customTipActive ? "active-styl" : ""),
                            onClick: function onClick(e) {
                                return _this2.setCustomTip(e);
                            },
                            tabIndex: 37
                            // tabIndex  = {10}
                            // tabIndex  = {-1}
                        },
                        _react2.default.createElement(
                            'b',
                            null,
                            'Custom'
                        ),
                        ' ',
                        _react2.default.createElement('br', null),
                        ' $',
                        !Utils.isEmpty(this.state.chosenCustomTip) ? this.state.chosenCustomTip.toFixed(2) : "0.00"
                    ),
                    this.state.showCustomTipField ? _react2.default.createElement(
                        'div',
                        { className: 'tip-input-holder mt-3' },
                        _react2.default.createElement(
                            'div',
                            { className: 'input-group input-group-sm mb-2' },
                            _react2.default.createElement('input', {
                                type: 'number',
                                name: 'custom-tip',
                                className: 'form-control',
                                placeholder: '0.00',
                                value: this.state.customTipInput,
                                onChange: this.handleChange,
                                onFocus: this.clearCustomInput,
                                onBlur: this.resetToPreviousState,
                                tabIndex: 38
                            }),
                            _react2.default.createElement(
                                'div',
                                { className: 'input-group-append' },
                                _react2.default.createElement(_SpinButton2.default, {
                                    classNames: 'btn btn-sm btn-styl font-weight-bold',
                                    buttonText: 'Add Tip',
                                    spinText: "Applying.. ",
                                    showSpinner: false,
                                    whenClicked: this.applyCustomTip.bind(this),
                                    showIcon: true,
                                    iconClass: "icofont-plus-circle mr-1",
                                    tabIndex: 39
                                })
                            )
                        )
                    ) : null
                )
            );
        }
    }]);

    return TipMain;
}(_react.Component);

exports.default = TipMain;


//////////////////
// WEBPACK FOOTER
// ./src/components/tip/TipMain.jsx
// module id = 733
// module chunks = 0